<template>
    <div class="site-panel w-100">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab">
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-select
                            v-model       = "type"
                            :label        = "$t('unit.type.label')"
                            module        = "msd"
                            type          = "siteType"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                            @input        = "onTypeChanged"
                        />
                    </v-col>
                </v-row>

                <div class="missing-data">
                    {{ $t('unit.type.noSpecification') }}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Core          from "@/modules/core/service/Core";
import Site          from "@/modules/msd/unit/service/Site";
import FEnumSelect   from "@/modules/core/components/utils/FEnumSelect.vue";

/**
 * Site type of a unit without technical data, e.g. doors and gates (group 3; HCIT-943): the office corrects the type,
 * e.g. to resolve a device type conflict of an inspection. Changed through `PUT /api/site/{id}/type`; a change of the
 * group is confirmed, cancelling restores the selection. Emits "type" with the changed site.
 */
export default {
    name: "TSiteType",

    components: {
        FEnumSelect,
    },

    props: {
        site: {

        },

        readonly: {

        },
    },

    data: () => ({
        type: null,
    }),

    mounted () {
        this.type = this.site ? this.site.type : null;
    },

    watch: {
        site () {
            this.type = this.site ? this.site.type : null;
        }
    },

    methods: {
        onTypeChanged () {
            const current = this.site.type;
            if (!this.type || !current || this.type.id === current.id) {
                return;
            }

            if (this.type.groupId === current.groupId) {
                this.storeType();
                return;
            }

            const query = this.$t("unit.type.change.query");
            const text  = this.$t("unit.type.change.text", [ current.name, this.type.name ]);

            Core.message.confirm(this, query, text, Core.message.Default, (confirmed) => {
                if (confirmed) {
                    this.storeType();
                } else {
                    this.type = current;
                }
            });
        },

        storeType () {
            Site.update.type(this.site.id, this.type.id).then(data => {
                this.$emit("type", data);
                Core.fire.saved(this, data);
            });
        },
    }
}
</script>

<style scoped>

.missing-data {
    padding-top: 16px;
    color: grey;
}

</style>
